import styled from 'styled-components'


export const FooterContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 100%;
`
export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`

export const CleanButton = styled.button`
    border: 0;
    background: transparent;
    color: #8c8c8cff;
    padding: 5px;
    transition: background-color 200 ease, transform 200 ease;

    &:hover {
        color: #363636ff;
    }
`